import { createAsyncAction } from 'typesafe-actions'
import { MessageState } from '../../types'
import { Failure, Request, Success } from './types'

export const editTextMessageAction = createAsyncAction(
  '@message/EDIT_TEXT_MESSAGE_REQUEST',
  '@message/EDIT_TEXT_MESSAGE_SUCCESS',
  '@message/EDIT_TEXT_MESSAGE_FAILURE'
)<Request, Success, Failure>()

const request = (state: MessageState): MessageState => ({
  ...state,
  isLoadingOnEditTextMessage: true
})

const success = (state: MessageState): MessageState => {
  return {
    ...state,
    isSuccessOnEditTextMessage: true,
    isLoadingOnEditTextMessage: false
  }
}

const failure = (state: MessageState): MessageState => {
  return {
    ...state,
    isLoadingOnEditTextMessage: false,
    isErrorOnEditTextMessage: true
  }
}

export const editTextMessageHandle = {
  asyncAction: editTextMessageAction,
  request,
  success,
  failure
}
